export default process.env.SAFE_PASSAGE_CONTRACT_ADDRESS ||
  '0x33249f97d4EE3f2EB7490f12FCd60c4B6Edf0Fc7';
